import * as find from './reducers/find';

// eslint-disable-next-line import/no-default-export
export default {
    LANGUAGES_FIND_REQUEST: find.request,
};
